import { render, staticRenderFns } from "./finuslugi-investment-campaign-progress.vue?vue&type=template&id=0f24d7a3&scoped=true&"
import script from "./finuslugi-investment-campaign-progress.vue?vue&type=script&lang=js&"
export * from "./finuslugi-investment-campaign-progress.vue?vue&type=script&lang=js&"
import style0 from "./finuslugi-investment-campaign-progress.vue?vue&type=style&index=0&id=0f24d7a3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f24d7a3",
  null
  
)

export default component.exports